import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { TabSection } from '@ui/kit';
import { useEmbedBoundaries, ComponentInteractionsProvider } from '@utils/component-framework';
import { useChangeEffect, SizeTransition } from '@utils/react';
import { useCurrentTask } from '../util.get-current-task.js';
import { transitionDurationMs, wrapper, transition } from './variant.embed.style.js';
import { jsx } from 'react/jsx-runtime';
import { IGuideContentRoot } from '../organism.content/organism.root.js';

function EmbedWrapper({
  onActivate,
  ...props
}) {
  const embedRef = useRef(null);
  useEmbedBoundaries(embedRef);
  const currentTask = useCurrentTask(props.component.data, props.component.entryKey);
  useChangeEffect(() => {
    setTimeout(() => {
      const taskRoot = embedRef.current?.querySelector("[data-task-root]");
      taskRoot?.focus({
        preventScroll: true
      });
    }, transitionDurationMs + 50);
  }, [currentTask?.index]);
  return /*#__PURE__*/jsx(ComponentInteractionsProvider, {
    onActivate: onActivate,
    children: /*#__PURE__*/jsx("div", {
      ref: embedRef,
      className: wrapper,
      children: /*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: /*#__PURE__*/jsx(SizeTransition, {
          axis: "vertical",
          swappable: true,
          timeout: transitionDurationMs,
          classNames: transition,
          delayMs: {
            enter: 10,
            exit: 0
          },
          children: ref => /*#__PURE__*/jsx(TabSection, {
            ref: ref,
            disabled: props.component.data.tasks.length === 1,
            baseId: props.tabId,
            selectedTabId: currentTask.task?.id,
            children: /*#__PURE__*/jsx(IGuideContentRoot, {
              ...props,
              currentTaskIndex: currentTask.index,
              className: transition
            })
          })
        }, currentTask.index)
      })
    })
  });
}

export { EmbedWrapper };
//# sourceMappingURL=variant.embed.js.map
